"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var API = /** @class */ (function () {
    function API() {
    }
    API.xmlHTTPRequest = function (options) {
        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.open(options.method, options.url);
            if (options.headers)
                for (var header in options.headers)
                    xhr.setRequestHeader(header, options.headers[header]);
            xhr.withCredentials = false;
            xhr.onload = function () {
                if (xhr.status === 200)
                    resolve(xhr.response);
                else
                    reject(xhr.response);
            };
            xhr.onerror = function () { reject(xhr.response); };
            xhr.send(JSON.stringify(options['params']));
        });
    };
    API.headers = function (contentType) {
        return {
            "Accept": "application/json",
            "Content-Type": contentType || "application/json"
        };
    };
    API.get = function (route, params) {
        return this.xhr(route, params, "GET");
    };
    API.put = function (route, params) {
        return this.xhr(route, params, "PUT");
    };
    API.post = function (route, params) {
        return this.xhr(route, params, "POST");
    };
    API.postWithFiles = function (route, params) {
        return this.xhr(route, params, "POST", "multipart/form-data");
    };
    API.delete = function (route, params) {
        return this.xhr(route, params, "DELETE");
    };
    API.patch = function (route, params) {
        return this.xhr(route, params, "PATCH");
    };
    API.xhr = function (route, params, verb, contentType) {
        var options = Object.assign({ method: verb, url: route }, params);
        options['headers'] = tslib_1.__assign(tslib_1.__assign({}, options.headers), API.headers(contentType));
        return API.xmlHTTPRequest(options)
            .catch(handleErrors)
            .then(function (responseData) { return handleData(responseData); });
    };
    return API;
}());
exports.default = API;
var handleData = function (data) { return JSON.parse(data); };
var handleErrors = function (error) {
    var _a = JSON.parse(error), status = _a.status, message = _a.message;
    if (status === 401) {
        throw new Error(message);
    }
    else if (status !== 200) {
        throw new Error(message || "Oops Something went Wrong!");
    }
    return Promise.reject(error);
};
